import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../../colorVars';
import { refineTimeStampArray } from './utils/refineTimeStampArray';
import style from './Labels.module.css';

const HorizontalLabels = ({ timeStampArray, size, scaleX, timeUnit }) => {
  const [timeStamps, setTimeStamps] = useState(null);
  useEffect(() => {
    if (timeStampArray){
      setTimeStamps(refineTimeStampArray(timeStampArray, timeUnit, scaleX));
    }

  }, [timeStampArray, scaleX, timeUnit]);
  return (
    <svg height={20} width={size} stroke={colors.white} fill={colors.white}>
      {timeStamps !== null &&
        timeStamps.map(({ xPos, time }) => (
          <text className={style.text} key={time + xPos} x={xPos} y={10} style={{ fontSize: '10px' }}>
            {time}
          </text>
        ))}
    </svg>
  );
};

HorizontalLabels.propTypes = {
  size: PropTypes.number,
  timeStampArray: PropTypes.array,
  timeUnit: PropTypes.string,
  scaleX: PropTypes.func,
};

export default HorizontalLabels;
